import "./Share.css";
import mail from "../../../../../assets/mail.png";
import messanger from "../../../../../assets/messanger.png";
import twitter from "../../../../../assets/twitter.png";
import leftArrow from "../../../../../assets/left-arrow.png";
import instagram from "../../../../../assets/instagram.png";
import sms from "../../../../../assets/sms.png";
import whatsapp from "../../../../../assets/whatsapp.png";

const Share = ({ setShareModal, setReferModal }) => {
 return (
  <div className="share-modal">
   <div className="overlay"></div>
   <div className="modal-box desktop">
    <div className="header">
     <p
      className="close-modal"
      onClick={() => {
       setShareModal(false);
       setReferModal(true);
      }}
     >
      <img src={leftArrow} alt="left arrow" />
     </p>
     <p className="title">Share link</p>
    </div>
    <div className="share-links-container">
     <div className="left">
      <div>
       <a href="/">
        <img src={mail} alt="SMS" />
        <p>Email</p>
       </a>
      </div>
      <div>
       <a href="/">
        <img src={whatsapp} alt="whatsapp" />
        <p>Whatsapp</p>
       </a>
      </div>
      <div>
       <a href="/">
        <img src={twitter} alt="twitter" />
        <p>Twitter</p>
       </a>
      </div>
     </div>

     <div className="right">
      <div>
       <a href="/">
        <img src={sms} alt="SMS" />
        <p>SMS</p>
       </a>
      </div>
      <div>
       <a href="/">
        <img src={messanger} alt="facebook messenger" />
        <p>Messenger</p>
       </a>
      </div>
      <div>
       <a href="/">
        <img src={instagram} alt="instagram" />
        <p>Instagram</p>
       </a>
      </div>
     </div>
    </div>
   </div>
   <div className="modal-box mobile">
    <div className="header">
     <p
      className="close-modal"
      onClick={() => {
       setShareModal(false);
       setReferModal(true);
      }}
     >
      <img src={leftArrow} alt="left arrow" />
     </p>
     <p className="title">Share link</p>
    </div>
    <div className="share-links-container">
     <div className="left">
      <div>
       <a href="/">
        <img src={mail} alt="SMS" />
        <p>Email</p>
       </a>
      </div>
      <div>
       <a href="/">
        <img src={whatsapp} alt="whatsapp" />
        <p>Whatsapp</p>
       </a>
      </div>
      <div>
       <a href="/">
        <img src={twitter} alt="twitter" />
        <p>Twitter</p>
       </a>
      </div>
     </div>

     <div className="right">
      <div>
       <a href="/">
        <img src={sms} alt="SMS" />
        <p>SMS</p>
       </a>
      </div>
      <div>
       <a href="/">
        <img src={messanger} alt="facebook messenger" />
        <p>Messenger</p>
       </a>
      </div>
      <div>
       <a href="/">
        <img src={instagram} alt="instagram" />
        <p>Instagram</p>
       </a>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default Share;
